/**
 * Карусель в hero-секции.
 *
 * - Автоплей: смена каждые 3 секунды.
 * - Пауза при наведении.
 * - Ручная смена: стрелки «назад/вперёд», клики по точкам.
 * - Свайп на тач-устройствах.
 * - Навигация с клавиатуры: стрелки ← → при фокусе на карусели.
 */
export function initHeroCarousel() {
  const carousel = document.querySelector("[data-carousel]");
  if (!carousel) return;

  const slides = carousel.querySelectorAll(".hero-carousel__slide");
  const dots = carousel.querySelectorAll("[data-carousel-dot]");
  const prevBtn = carousel.querySelector("[data-carousel-prev]");
  const nextBtn = carousel.querySelector("[data-carousel-next]");

  if (slides.length < 2) return;   // нечего листать

  const INTERVAL = 9000;            // 3 секунды
  let current = 0;
  let timer = null;
  let paused = false;

  // ─── Управление ──────────────────────────────────
  function goTo(index) {
    // Зацикливаем
    current = (index + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      slide.classList.toggle("is--active", i === current);
    });
    dots.forEach((dot, i) => {
      dot.classList.toggle("is--active", i === current);
    });
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  // ─── Автоплей ────────────────────────────────────
  function startTimer() {
    stopTimer();
    timer = setInterval(() => {
      if (!paused) next();
    }, INTERVAL);
  }

  function stopTimer() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  // ─── Обработчики ─────────────────────────────────
  if (nextBtn) nextBtn.addEventListener("click", next);
  if (prevBtn) prevBtn.addEventListener("click", prev);

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      goTo(parseInt(dot.dataset.carouselDot, 10));
    });
  });

  // Пауза при наведении
  carousel.addEventListener("mouseenter", () => { paused = true; });
  carousel.addEventListener("mouseleave", () => { paused = false; });

  // Пауза при фокусе (клавиатурная навигация)
  carousel.addEventListener("focusin", () => { paused = true; });
  carousel.addEventListener("focusout", () => { paused = false; });

  // Пауза, когда вкладка неактивна (не крутим в фоне)
  document.addEventListener("visibilitychange", () => {
    paused = document.hidden;
  });

  // Клавиатура: ← →
  carousel.setAttribute("tabindex", "-1");
  carousel.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft")  { e.preventDefault(); prev(); }
    if (e.key === "ArrowRight") { e.preventDefault(); next(); }
  });

  // ─── Свайп ───────────────────────────────────────
  let touchStartX = 0;
  let touchStartY = 0;

  carousel.addEventListener("touchstart", (e) => {
    const t = e.changedTouches[0];
    touchStartX = t.clientX;
    touchStartY = t.clientY;
  }, { passive: true });

  carousel.addEventListener("touchend", (e) => {
    const t = e.changedTouches[0];
    const dx = t.clientX - touchStartX;
    const dy = t.clientY - touchStartY;

    // Обрабатываем только горизонтальные свайпы
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;

    if (dx < 0) next();  // свайп влево — следующий
    else prev();         // свайп вправо — предыдущий
  }, { passive: true });

  // ─── Старт ───────────────────────────────────────
  goTo(0);
  startTimer();
}
